import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { runEarlyClientRecovery } from "@/lib/clientRecovery";

runEarlyClientRecovery();

/** Deploy után régi index.html + hiányzó JS chunk → fehér képernyő (Chrome/Safari cache). */
const CHUNK_RELOAD_KEY = "autopark_chunk_reload_v1";
function maybeReloadOnStaleBundle(reason) {
  const msg = String(reason?.message || reason || "");
  if (!/Loading chunk|ChunkLoadError|Failed to fetch dynamically imported module/i.test(msg)) return;
  try {
    if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
    window.location.reload();
  } catch {
    window.location.reload();
  }
}
window.addEventListener("unhandledrejection", (e) => maybeReloadOnStaleBundle(e.reason));
window.addEventListener(
  "error",
  (e) => {
    if (e.message?.includes("Loading chunk") || e.message?.includes("ChunkLoadError")) {
      maybeReloadOnStaleBundle(e.error || e.message);
    }
  },
  true,
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
